import React from 'react';
import { useModelContext } from '../Layout';
import { TailwindSelect } from '../Tailwind';

/**
 * Scenario selector shared across every BPO section (Edit, Valuation, Tools).
 * Lives in the top-right `actions` slot of each section's FMEPageHeader so the
 * control sits in the same place with the same look everywhere — consistent
 * with how scenario selection is surfaced elsewhere in the webapp.
 *
 * Scenario-only (no sensitivity dropdown): the operational data flow keys off
 * the current scenario, and the redesigned BPO mirrors that.
 */
export default function OperationalScenarioSelector() {
    const { model, currentScenario, setCurrentScenario } = useModelContext();
    if (!model?.modelScenarios?.length) return null;

    const options = model.modelScenarios.map((s: any) => ({
        value: s.id.toString(),
        label: s.name,
    }));

    return (
        <div style={{ minWidth: 200 }}>
            <TailwindSelect
                label="Scenario"
                value={currentScenario?.id?.toString() || ''}
                onChange={(value: string) => {
                    const scenario = model.modelScenarios.find((s: any) => s.id.toString() === value);
                    if (scenario) setCurrentScenario(scenario);
                }}
                options={options}
                placeholder="Select scenario"
            />
        </div>
    );
}
